@if (cardInfo(); as cardInfo) {
  <div>
    <crm-activity-rich-text [richText]="cardInfo.body"></crm-activity-rich-text>
    @if (callRecordingSource$ | async; as callUrl) {
      <audio class="activity-data-call-recording" preload="metadata" controls src="{{ callUrl }}">
        {{ 'ACTIVITY.AUDIO_PLAYBACK_ERROR' | translate }}
      </audio>
    }
    <div class="row">
      <ng-container
        [ngTemplateOutlet]="activityData"
        [ngTemplateOutletContext]="{ label: 'ACTIVITY.STATUS', value: cardInfo.status }"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="activityData"
        [ngTemplateOutletContext]="{ label: 'ACTIVITY.OUTCOME', value: cardInfo.outcome }"
      ></ng-container>
    </div>
  </div>
}

<ng-template #activityData let-label="label" let-value="value">
  <div class="col col-xs-12 col-md-4">
    <div class="activity-data-label">
      {{ label | translate }}
    </div>
    <div class="activity-data-value">
      <!-- ng-container necessary so angular interpolation will add empty -->
      @if (value) {
        <ng-container>
          {{ value }}
        </ng-container>
      }
    </div>
  </div>
</ng-template>
